<template>
  <div class="content-width py-4">
    <div class="member-tab" v-if="isMobile">
      <ul class="nav nav-tabs" :class="{ 'nav-justified': isMobile }">
        <li class="nav-item">
          <router-link :to="{ name: '汽車品牌' }" v-slot="{ href, isActive }">
            <a class="nav-link style" :class="{ active: isActive }" :href="href"
              >汽車品牌</a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: '零件品牌' }" v-slot="{ href, isActive }">
            <a class="nav-link style" :class="{ active: isActive }" :href="href"
              >零件品牌</a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: '零件分類' }" v-slot="{ href, isActive }">
            <a class="nav-link part" :class="{ active: isActive }" :href="href"
              >零件分類</a
            >
          </router-link>
        </li>
      </ul>
    </div>
    <router-view :isMobile="isMobile" :token="token"></router-view>
  </div>
</template>
<style lang="scss" scoped>
.member-tab {
  background-color: #fff;
  .nav-tabs {
    border: none;
    .nav-link {
      color: #666;
      position: relative;
      font-size: 14px;
      &::after {
        content: "";
        width: 0;
        left: 50%;
        transform: translate(-50%, 50%);
        transition: all 0.3s ease-in-out;
      }
      &:hover,
      &:focus {
        border-color: transparent;
        &::after {
          content: "";
          width: 100%;
          height: 3px;
          background-color: #666;
          position: absolute;
          bottom: 0;
        }
      }
    }
    .nav-link.active,
    .nav-item.show .nav-link {
      border: none;
      color: #fff;
      background-color: $manage_main;
      &::after {
        content: "";
        width: 100%;
        height: 3px;
        background-color: $manage_sub;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
</style>
<script>
export default {
  name: "Category",
  props: ["isMobile", "token"]
};
</script>
